<div class="pt-65px"></div>
<div class="container-fluid">
  <h3>Joining Project...</h3>

  <p *ngIf="errorString" class="text-danger">
    {{ errorString }}
  </p>
</div>
